import React, { useEffect, useState } from 'react';

import { intervalUpdatingData, set_status, showStatusBooking, showTypeBooking } from '../../utils/dynamic';

import { fetchData, formatDate } from '../../utils/api';
import { apiUrl } from '../../config'
import BookingEdit from './bookings/BookingEdit'
import BookingView from './bookings/BookingView'
import BookingNew from './bookings/BookingNew'
import { useLanguage } from '../../LanguageContext';
import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';

const NoPaymentBookings = () => {
  const { language: adminLanguage } = useAdminLanguage();
  const translate = (text) => translateAdmin(text, adminLanguage);
  const { language } = useLanguage();
  const [bookings, setBookings] = useState([])
  const [bookingsMessage, setBookingsMessage] = useState([])
  const [messageBook, setMessageBook] = useState('')
  if (messageBook.length !== 0) {
    setTimeout(() => {
      setMessageBook('')
    }, 3000)
  }
  const [loading, setLoading] = useState(false); // состояние для отслеживания загрузки

  const [isEditOpen, setIsEditOpen] = useState(false); // состояние для показа формы редактирования записи
  const [isViewOpen, setIsViewOpen] = useState(false); // состояние для просмотра записи
  const [isNewOpen, setIsNewOpen] = useState(false); // состояние для добавления записи
  const [editData, setEditData] = useState([]); // состояние с данными для редактирования записи
  const [viewData, setViewData] = useState([]); // состояние с данными для просмотра записи

  const [searchQuery, setSearchQuery] = useState(''); // состояние для поиска

  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' }); // состояние для сортировки по дате заезда/выезда

  // Handle VIEW/EDIT/DELETE click
  const handleVEDNClick = (booking, action) => {
    switch (action) {
      case 'accept':
        setViewData(booking)
        break;
      case 'view':
        setViewData(booking)
        setIsViewOpen(true);
        break;
      case 'edit':
        setEditData(booking)
        setIsEditOpen(true);
        break;
      case 'new':
        setIsNewOpen(true);
        break;
      default:
        break
    }
  };
  const set_statusComp = async (bookingId, method) => {
    const res = await set_status(bookingId, method)
    if (res) {
      setMessageBook(res)
      fetchGAB();
    }
  }
  // Handle VIEW/EDIT closer
  const handleVENClose = () => {
    setIsViewOpen(false);
    setIsEditOpen(false);
    setIsNewOpen(false);
  };

  const fetchGAB = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const data = await fetchData(`${apiUrl}/api/sys/get-nop-bookings`, "GET", token);
  
      if (data.request.status === 0) {
        // Создаем маппинг для rooms и customers по их ID
        const roomsMap = new Map(data.request.data.rooms.map(room => [room.id, room]));
  
        // Обработка данных booking
        const processedData = data.request.data.booking.map((booking) => {
          const room = roomsMap.get(booking.room_id);
  
          return {
            ...booking,
            room_type: room?.translations?.room_type?.[language] || '', // Тип номера
            price: room?.price || '', // Цена за первые сутки номера
            book_price: data.request.data.book_price || '', // Цена за бронь
          };
        });
  
        // Обновляем состояние
        setBookings(processedData);
        setLoading(false); // Останавливаем загрузку
      } else {
        setBookingsMessage(data.request.message || "Ошибка загрузки данных");
      }
    } catch (error) {
      console.error("Ошибка:", error);
      setBookingsMessage("Произошла ошибка при загрузке данных");
    }
  };
  useEffect(() => {
    fetchGAB();
    // Обновление данных каждые n секунд
    const interval = setInterval(() => {
      setLoading(true)
      setTimeout(() => {
        fetchGAB();
      }, 3000)
    }, intervalUpdatingData);
    // Очистка интервала при размонтировании компонента
    return () => clearInterval(interval);
  }, []);


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredBookings = bookings.filter((booking) => 
    (booking.room_type && booking.room_type.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (booking.card_number && booking.card_number.includes(searchQuery)) ||
    (booking.cardholdername && booking.cardholdername.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (booking.phone_number && booking.phone_number.includes(searchQuery)) ||
    (booking.available_from && booking.available_from.includes(searchQuery)) ||
    (booking.available_to && booking.available_to.includes(searchQuery)) ||
    (booking.book_number && booking.book_number.includes(searchQuery))
  );
  const handleSort = (key) => {
    let direction = 'asc';
  
    // Меняем направление, если сортируем по тому же полю
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedAndFilteredBookings = [...filteredBookings].sort((a, b) => {
    if (sortConfig.key) {
        const dateA = new Date(formatDate(a[sortConfig.key]));
        const dateB = new Date(formatDate(b[sortConfig.key]));
        if (dateA < dateB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (dateA > dateB) return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Функция для отображения стрелки
  const renderSortArrow = (key) => {
    if (sortConfig.key === key) {
        return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return "▼"; // стрелка по умолчанию
  };

  return (
      <>
        <section className="system-bookings-table">
          <h2 className='system-bookings-table__title'>{translate('Не оплаченые бронирования')}</h2>
          <div className='d-flex just-content-sb'>
            <div className='d-flex just-content-sb'>
              <button className="system-booking-table-btn system-booking-table-btn-edit" onClick={() => handleVEDNClick(null, 'new')}>➕</button>
              <input
                  type="text" 
                  placeholder={translate('Поиск по тел/имени...')}
                  value={searchQuery} 
                  onChange={handleSearchChange} 
                  className="search-input search-field" 
              />
            </div>

            {loading && (
              <div className="loader">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
              </div>
            )}
          </div>
          <h3 className='success-message'>{messageBook}</h3>

          <table className='system-table'>
            <thead className='system-thead'>
              <tr className='system-tr'>
                <th className='system-th search-field'>№</th>
                <th className='system-th search-field'>{translate('Тип номера')}</th>
                <th className='system-th'>{translate('Почта')}</th>
                {/* <th className='system-th search-field'><AdminText>Имя плательщика</AdminText></th> */}
                <th className='system-th search-field'>{translate('Тип брони')}</th>
                <th className='system-th search-field'>{translate('Тел.')}</th>
                <th className='system-th system-th__cursor' onClick={() => handleSort('available_from')}>{translate('Дата заезда')} {renderSortArrow('available_from')}</th>
                <th className='system-th system-th__cursor' onClick={() => handleSort('available_to')}>{translate('Дата выезда')} {renderSortArrow('available_to')}</th>
                <th className='system-th'>{translate('Статус')}</th>
                <th className='system-th'>{translate('Общая сумма')}</th>
                <th className='system-th'>{translate('Действия')}</th>
                <th className='system-th'></th>
              </tr>
            </thead>
            <tbody className='system-tbody'>

            {sortedAndFilteredBookings && sortedAndFilteredBookings.length > 0 ? (
              <React.Fragment>
              {sortedAndFilteredBookings.map((booking, index) => (
                <tr className="system-tr" key={index + 1}>
                  <td className="system-td">{booking.book_number}</td>
                  <td className="system-td">{booking.room_type}</td>
                  <td className="system-td">{booking.email}</td>
                  {/* <td className="system-td">{booking.cardholdername}</td> */}
                  <td className="system-td">{translate(showTypeBooking(booking.type))}</td>
                  <td className="system-td">{booking.phone_number}</td>
                  <td className="system-td">{booking.available_from}</td>
                  <td className="system-td">{booking.available_to}</td>
                  <td className="system-td">{translate(showStatusBooking(booking.status))}</td>
                  <td className="system-td">{booking.amount}</td>
                  <td className="system-td">
                    {booking.status === 2 && (
                      <button className="system-booking-table-btn system-booking-table-btn-view" onClick={() => set_statusComp(booking.id, 'acceptPayment')}>{translate('Подт. оплату')}</button>
                    )}
                    <button className="system-booking-table-btn system-booking-table-btn-view" onClick={() => handleVEDNClick(booking, 'view')}>{translate('Посмотреть')}</button>
                    {/* <button className="system-booking-table-btn system-booking-table-btn-edit" onClick={() => handleVEDNClick(booking, 'edit')}><AdminText>Изменить</AdminText></button> */}

                  </td>
                  <td className="system-td">{booking.reception_status === 0 || booking.reception_status === 1 ? ("✅") : "❌"}</td>
                </tr>
              ))}
              </React.Fragment>
            ) : (
              <tr>
                <td className="system-td">{bookingsMessage}</td>
              </tr>
            )}
            </tbody>
          </table>
        </section>
        {isEditOpen && (
          <BookingEdit booking={editData} onClose={handleVENClose} />
        )}
        {isViewOpen && (
          <BookingView booking={viewData} onClose={handleVENClose} />
        )}
        {isNewOpen && (
          <BookingNew onClose={handleVENClose} />
        )}
      </>
  );
};

export default NoPaymentBookings;